<template>
  <div>
    <vs-prompt :vs-title="' # title'" vs-cancel-text="Vazgeç" vs-button-cancel="border" @vs-close="cancel" @vs-cancel="cancel" :vs-active.sync="visible" vs-accept-text="Kaydet" @vs-accept="submit" :vs-is-valid="validateForm">
      <vcl-table secondary="#ff9f43" v-if="loading"></vcl-table>
      <div v-else class="px-4">
        <div class="vx-row">
          <table border="1" class="w-full">
            <thead>
              <tr>
                <th>#</th>
                <th class="w-2/3 p-2">Ürün</th>
                <th class="w-1/8 p-2">Miktar</th>
                <th class="w-1/8 p-2">İade Miktar</th>
                <th class="w-1/4 p-2">Depo</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(tr, index) in productList" :key="index">
                <th class="px-2">{{ index + 1 }}</th>
                <td class="w-2/3 px-2">{{ tr.name }}</td>
                <td class="px-2">{{ tr.productAmount }}</td>
                <td class="px-2">
                  <input style="width: 50px;" type="number" v-model="tr.returnAmount" :max="tr.productAmount" @change="checkAmount(tr)" @focus="$event.target.select()" min="0" />
                </td>
                <td class="p-2">
                  <vs-select class="w-full" v-model="tr.warehouseId">
                    <vs-select-item :key="index" :value="item.id" :text="item.value" v-for="(item, index) in warehouses" />
                  </vs-select>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import { repository } from "@/_services/repository.js";
import { VclTable } from "vue-content-loading";
import vSelect from "vue-select";

export default {
  components: {
    vSelect,
    VclTable,
  },

  props: {
    value: Object,
  },
  data() {
    return {
      visible: true,
      loading: true,
      productList: [],
      warehouses: [],
    };
  },
  computed: {
    validateForm() {
      return !this.errors.any();
    },
  },
  created() {
    this.getData();
    this.getWareHouse();
  },
  methods: {
    getWareHouse: async function () {
      let a = await repository.getAll("B2B/getWarehouses");
      this.warehouses = a.list;
    },
    getData: async function () {
      this.loading = false;
      for (let i = 0; i < this.value.products.length; i++) {
        let p = this.value.products[i];
        let rc = p.returnedCount || 0;
        //'[{"id":25978,"productId":1407,"productAmount":5,"warehouseId":3}]'
        if (p.status && !p.deleted && rc < p.productAmount) {
          this.productList.push({
            id: p.orderLineId,
            productId: p.productId,
            name: p.productName,
            orderId: p.orderId,
            productAmount: p.productAmount,
            warehouseId: p.wareHouseId,
            returnAmount: 0,
          });
        }
      }
      console.log(this.value);
    },
    checkAmount(tr) {
      if (tr.returnAmount > tr.productAmount) {
        tr.returnAmount = tr.productAmount;
        return;
      }
      if (tr.returnAmount < 0) tr.returnAmount = 0;
    },
    cancel() {
      this.visible = true;
      this.$emit("updateCompleted", 0);
    },
    submit: async function () {
      let model = {};
      let lines = [];
      for (let i = 0; i < this.productList.length; i++) {
        let p = this.productList[i];
        if (p.returnAmount > 0) {
          if (p.returnAmount > p.productAmount) p.returnAmount = p.productAmount;
          lines.push({
            id: p.id,
            orderId: p.orderId,
            productId: p.productId,
            productAmount: p.returnAmount,
            warehouseId: p.warehouseId,
          });
        }
      }
      if (lines.length > 0) {
        model = {
          id: this.value.saleOrderId,
          value: JSON.stringify(lines),
        };
        let r = await repository.postEntity("B2B/createReturnRequest", model);
        if (r && r.isSuccessful) {
          this.$vs.notify({
            title: "Ok",
            text: "İade isteği oluşturuldu",
            color: "success",
          });
        } else {
          this.$vs.notify({
            title: "Hata",
            text: (r && r.exceptionMessage) || "Bilinmeyen hata",
            color: "danger",
          });
        }
      }
      console.log("model", model);
      this.visible = true;
      this.$emit("updateCompleted", 5);
    },
  },
};
</script>

<style></style>
